import { DateTime } from 'luxon';
import { TranslationService } from '../../../../../../../../../services/translation.service';
import { DateHelper } from '../../../../../../../../../helpers/date.helper';

function EstimatedAndPlannedTimes({
  estimatedTime,
  plannedTime,
  isCancelled,
  className,
}: {
  estimatedTime: string | undefined;
  plannedTime: string | undefined;
  isCancelled: boolean;
  className?: string;
}) {
  if (!estimatedTime && !plannedTime) {
    return null;
  }

  const isOnTime = !estimatedTime || !plannedTime || DateTime.fromISO(estimatedTime).equals(DateTime.fromISO(plannedTime));

  return (
    <div className={className}>
      {!isOnTime && (
        <span>
          <span className="visually-hidden">
            {TranslationService.get('travelplanner.estimated')} {TranslationService.get('travelplanner.time')}:
          </span>
          <span>{DateHelper.getTimeFromDateTimeString(estimatedTime)}</span>
        </span>
      )}
      {plannedTime && (
        <span>
          <span className="visually-hidden">
            {TranslationService.get('travelplanner.planned')} {TranslationService.get('travelplanner.time')}:
          </span>
          <span className={`${!isOnTime ? 'text-decoration-line-through ms-1 text-color-gray-800' : ''} ${isCancelled ? 'text-danger text-decoration-line-through' : ''}`}>
            {DateHelper.getTimeFromDateTimeString(plannedTime)}
          </span>
        </span>
      )}
      {isCancelled && <span className="text-danger ms-1 mb-1">{TranslationService.get('common.cancelled')}</span>}
    </div>
  );
}

export default EstimatedAndPlannedTimes;
